import React, { useState, useEffect } from "react"
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import { Ridecell } from "@ridecell/web-sdk"
import {
  JumboCard,
  Typography,
  Box,
  Icons,
  withStyles,
} from "@ridecell/web-components-material"

import SetupForm from "./SetupForm"
import useGlobalContext from "../../../../utils/customHooks/useGlobalContext"
import styles from "../styles"
import fetchStripePublicKey from "./fetchStripePublicKey"

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// Note: Please do create a ticket If we have the any other approach to load it .
let stripePromise
;(async () => {
  const resp = await fetchStripePublicKey()
  stripePromise = loadStripe(resp)
})()

const StripeForm = ({
  classes,
  customerId,
  handleNext,
  headerText,
  onClose,
  returnUrl,
}) => {
  const { setError, toggleBackdrop } = useGlobalContext()
  const [clientSecret, setClientSecret] = useState("")
  const query = new URLSearchParams(window.location.search)
  const retrievedIntentSecret = query.get("setup_intent_client_secret")

  useEffect(() => {
    ;(async () => {
      try {
        toggleBackdrop(true)
        const response = await Ridecell.fetchPaymentSheet({
          customer_id: customerId,
        })
        setClientSecret(response.setup_intent_secret)
      } catch (e) {
        setError(e)
        if (onClose) {
          onClose()
        }
      } finally {
        toggleBackdrop(false)
      }
    })()
  }, [])

  const appearance = {
    theme: "stripe",
  }
  const options = {
    appearance,
    clientSecret,
  }

  return (
    <React.Fragment>
      {clientSecret && (
        <JumboCard
          className={classes.card}
          flexDirection="row"
          header={false}
          last={false}
        >
          {headerText && onClose && !retrievedIntentSecret && (
            <Box display="flex" justifyContent="space-between" pb={"20px"}>
              <Typography variant="body1" style={{ fontWeight: 600 }}>
                {headerText}
              </Typography>
              <Icons.Cancel onClick={onClose} style={{ cursor: "pointer" }} />
            </Box>
          )}
          <Elements options={options} stripe={stripePromise}>
            <SetupForm
              customerId={customerId}
              handleNext={handleNext}
              returnUrl={returnUrl}
              setError={setError}
              toggleBackdrop={toggleBackdrop}
            />
          </Elements>
        </JumboCard>
      )}
    </React.Fragment>
  )
}

export default withStyles(styles)(StripeForm)
